import * as React from 'react';

const BusinessHoursTable = ({
                           days,
                           businessHours,
                           setBusinessHours,
                           generalHours,
                           setGeneralHours,
                            language,
                            t
                       }) => {

    return (
        <div>
            <table className="table table-striped ">
                <thead className="thead-dark">
                <tr>
                    <th className="text-center h5">{t('days')}</th>
                    <th>{t('player_opening')}</th>
                    <th>{t('player_closing')}</th>
                    <th>{t('player_open_times')}</th>
                </tr>
                </thead>
                <tbody>
                {days.map((day, index) => {
                    return (
                        <tr className="table-sm" key={index}>
                            <td className="text-center h4">{day}</td>
                            <td>
                                <input
                                    type="time"
                                    onChange={(e) => {
                                        //setOpenHoursFrom(e.target.value);
                                        setBusinessHours((previousHours) => {
                                            const idk = [...previousHours];
                                            idk[index].from = e.target.value;
                                            return idk;
                                        });
                                    }}
                                    value={businessHours[index].from}
                                />
                            </td>
                            <td>
                                <input
                                    type="time"
                                    onChange={(e) => {
                                        setBusinessHours((previousHours) => {
                                            const idk = [...previousHours];
                                            idk[index].to = e.target.value;
                                            return idk;
                                        });
                                    }}
                                    value={businessHours[index].to}
                                />
                            </td>
                            <td className="text-uppercase center align-middle font-weight-bold d-flex">
                                <div className="ml-4 mr-2">
                                    <input
                                        type="checkbox"
                                        checked={businessHours[index].open}
                                        onChange={(e) =>
                                            setBusinessHours((previousHours) => {
                                                const idk = [...previousHours];
                                                idk[index].open = e.target.checked;
                                                return idk;
                                            })
                                        }
                                    />
                                </div>
                                <div className="d-flex">
                                    {businessHours[index].open ? t('open') : t('closed')}
                                </div>
                            </td>
                        </tr>
                    );
                })}
                </tbody>
                <tfoot>


                <tr className="table-primary table-sm">
                    <td className="text-center h4 ">
                        <strong>{t('player_general_open_time')}</strong>
                    </td>
                    <td>
                        <input
                            type="time"
                            value={generalHours.from}
                            onChange={(e) => {
                                setGeneralHours({
                                    ...generalHours,
                                    from: e.target.value,
                                });
                                businessHours.forEach((obj, index) =>
                                    setBusinessHours((previousHours) => {
                                        const idk = [...previousHours];
                                        idk[index].from = e.target.value;
                                        return idk;
                                    })
                                );
                            }}
                        />
                    </td>
                    <td>
                        <input
                            type="time"
                            value={generalHours.to}
                            onChange={(e) => {
                                setGeneralHours({...generalHours, to: e.target.value});
                                businessHours.forEach((obj, index) =>
                                    setBusinessHours((previousHours) => {
                                        const idk = [...previousHours];
                                        idk[index].to = e.target.value;
                                        return idk;
                                    })
                                );
                            }}
                        />
                    </td>
                    <td className="text-uppercase center align-middle font-weight-bold d-flex">
                        <div className="ml-4 mr-2">
                            <input
                                type="checkbox"
                                checked={generalHours.open}
                                onChange={(e) => {
                                    setGeneralHours({
                                        ...generalHours,
                                        open: e.target.checked,
                                    });
                                    businessHours.forEach((obj, index) =>
                                        setBusinessHours((previousHours) => {
                                            const idk = [...previousHours];
                                            idk[index].open = e.target.checked;
                                            return idk;
                                        })
                                    );
                                }}
                            />
                        </div>
                        <div className="d-flex">
                            {generalHours.open ? t('open') : t('closed')}
                        </div>
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default BusinessHoursTable;
